.accordionRoot {
  border-radius: var(--haus-facetFiltersAccordion__accordionRoot__border-radius, 0);
  padding: var(--haus-filters__accordionSection__padding, 24px 0);
  border-top: var(--haus-filters__accordionSection__border-top, 1px solid rgba(0, 0, 0, 0.1));
}

.firstAccordionRoot {
  padding-top: var(--haus-filters__accordionSection__first-child__padding-top, 0);
  border-top: var(--haus-filters__accordionSection__first-child__border-top, none);
}

.accordionItem {
  border-bottom: var(--haus-facetFiltersAccordion__accordionItem__border-bottom, none);

  &:last-child {
    border-bottom: var(
      --haus-facetFiltersAccordion__accordionItem__last-child__border-bottom,
      none
    );
  }
}

.accordionHeader {
  margin: var(--haus-facetFiltersAccordion__accordionHeader__margin, 0);
}

.accordionTrigger {
  width: var(--haus-facetFiltersAccordion__accordionTrigger__width, 100%);
  display: flex;
  align-items: var(--haus-facetFiltersAccordion__accordionTrigger__align-items, center);
  justify-content: var(
    --haus-facetFiltersAccordion__accordionTrigger__justify-content,
    space-between
  );
  gap: var(--haus-facetFiltersAccordion__accordionTrigger__gap, 8px);
  padding: var(--haus-facetFiltersAccordion__accordionTrigger__padding, 0 8px);
  border: var(--haus-facetFiltersAccordion__accordionTrigger__border, none);
  border-radius: var(--haus-facetFiltersAccordion__accordionTrigger__border-radius, 0);
  background: var(--haus-facetFiltersAccordion__accordionTrigger__background, transparent);
  color: var(--haus-facetFiltersAccordion__accordionTrigger__color, var(--haus-color-body));
  font-family: var(
    --haus-facetFiltersAccordion__accordionTrigger__font-family,
    var(--haus-typography-body-font-family)
  );
  font-size: var(--haus-facetFiltersAccordion__accordionTrigger__font-size, 16px);
  font-weight: var(--haus-facetFiltersAccordion__accordionTrigger__font-weight, 700);
  text-align: var(--haus-facetFiltersAccordion__accordionTrigger__text-align, start);
  text-transform: var(--haus-facetFiltersAccordion__accordionTrigger__text-transform, capitalize);
  cursor: var(--haus-facetFiltersAccordion__accordionTrigger__cursor, pointer);

  &:hover {
    background: var(--haus-facetFiltersAccordion__accordionTrigger__hover__background, transparent);
  }
}

.accordionChevron {
  flex-shrink: var(--haus-facetFiltersAccordion__accordionChevron__flex-shrink, 0);
  transition: var(--haus-facetFiltersAccordion__accordionChevron__transition, transform 200ms ease);
}

.accordionTrigger[data-state='open'] .accordionChevron {
  transform: rotate(180deg);
}

.accordionContent {
  overflow: var(--haus-facetFiltersAccordion__accordionContent__overflow, hidden);

  &[data-state='open'] {
    animation: accordionSlideDown 200ms ease-out;
  }

  &[data-state='closed'] {
    animation: accordionSlideUp 200ms ease-in;
  }
}

@keyframes accordionSlideDown {
  from {
    height: var(--haus-facetFiltersAccordion__accordionContent__open__height, 0);
  }
  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes accordionSlideUp {
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: var(--haus-facetFiltersAccordion__accordionContent__closed__height, 0);
  }
}

.filtersGroupContent {
  padding: var(--haus-facetFiltersAccordion__filtersGroupContent__padding, 12px 0 0 0);
  display: var(--haus-facetFiltersAccordion__filtersGroupContent__display, grid);
  gap: var(--haus-facetFiltersAccordion__filtersGroupContent__gap, 0);
}

.showMoreButton {
  display: var(--haus-facetFiltersAccordion__showMoreButton__display, flex);
  align-items: var(--haus-facetFiltersAccordion__showMoreButton__align-items, center);
  justify-content: var(--haus-facetFiltersAccordion__showMoreButton__justify-content, flex-start);
  gap: var(--haus-facetFiltersAccordion__showMoreButton__gap, 4px);
  width: var(--haus-facetFiltersAccordion__showMoreButton__width, 100%);
  padding: var(--haus-facetFiltersAccordion__showMoreButton__padding, 8px);
  margin-top: var(--haus-facetFiltersAccordion__showMoreButton__margin-top, 4px);
  border: var(--haus-facetFiltersAccordion__showMoreButton__border, none);
  border-radius: var(--haus-facetFiltersAccordion__showMoreButton__border-radius, 8px);
  background: var(--haus-facetFiltersAccordion__showMoreButton__background, transparent);
  font-family: var(
    --haus-facetFiltersAccordion__showMoreButton__font-family,
    var(--haus-typography-body-font-family)
  );
  font-size: var(--haus-facetFiltersAccordion__showMoreButton__font-size, 14px);
  font-weight: var(--haus-facetFiltersAccordion__showMoreButton__font-weight, 700);
  color: var(--haus-facetFiltersAccordion__showMoreButton__color, var(--haus-color-body));
  cursor: var(--haus-facetFiltersAccordion__showMoreButton__cursor, pointer);

  &:hover {
    color: var(
      --haus-facetFiltersAccordion__showMoreButton__hover__color,
      var(--haus-color-primary)
    );
  }
}

.showMoreIcon {
  flex-shrink: var(--haus-facetFiltersAccordion__showMoreIcon__flex-shrink, 0);
  width: var(--haus-facetFiltersAccordion__showMoreIcon__width, 16px);
  height: var(--haus-facetFiltersAccordion__showMoreIcon__height, 16px);
}

.checkboxItem {
  display: var(--haus-facetFiltersAccordion__checkboxItem__display, flex);
  align-items: var(--haus-facetFiltersAccordion__checkboxItem__align-items, center);
  gap: var(--haus-facetFiltersAccordion__checkboxItem__gap, 10px);
  width: var(--haus-facetFiltersAccordion__checkboxItem__width, 100%);
  box-sizing: var(--haus-facetFiltersAccordion__checkboxItem__box-sizing, border-box);
  padding: var(--haus-facetFiltersAccordion__checkboxItem__padding, 8px);
  border-radius: var(--haus-facetFiltersAccordion__checkboxItem__border-radius, 8px);
  font-size: var(--haus-facetFiltersAccordion__checkboxItem__font-size, 14px);
  line-height: var(--haus-facetFiltersAccordion__checkboxItem__line-height, 1.2);
  color: var(--haus-facetFiltersAccordion__checkboxItem__color, var(--haus-color-body));
  font-family: var(
    --haus-facetFiltersAccordion__checkboxItem__font-family,
    var(--haus-typography-body-font-family)
  );
  cursor: var(--haus-facetFiltersAccordion__checkboxItem__cursor, pointer);

  &:hover {
    background-color: var(
      --haus-facetFiltersAccordion__checkboxItem__hover__background-color,
      #f6f6f6
    );
    color: var(--haus-facetFiltersAccordion__checkboxItem__hover__color, var(--haus-color-body));
  }
}

.checkboxRoot {
  flex: var(--haus-facetFiltersAccordion__checkboxRoot__flex, 0 0 20px);
  width: var(--haus-facetFiltersAccordion__checkboxRoot__width, 20px);
  height: var(--haus-facetFiltersAccordion__checkboxRoot__height, 20px);
  border-radius: var(--haus-facetFiltersAccordion__checkboxRoot__border-radius, 4px);
  display: var(--haus-facetFiltersAccordion__checkboxRoot__display, flex);
  align-items: var(--haus-facetFiltersAccordion__checkboxRoot__align-items, center);
  justify-content: var(--haus-facetFiltersAccordion__checkboxRoot__justify-content, center);
  background-color: var(--haus-facetFiltersAccordion__checkboxRoot__background-color, #fff);
  border: 1px solid var(--haus-facetFiltersAccordion__checkboxRoot__border, rgba(0, 0, 0, 0.1));

  .checkboxItem:has(input:focus-visible) & {
    outline: var(
      --haus-facetFiltersAccordion__checkboxRoot__focus__outline,
      2px solid -webkit-focus-ring-color
    );
    outline-offset: var(--haus-facetFiltersAccordion__checkboxRoot__focus__outline-offset, 0);
  }

  &[data-state='checked'] {
    background-color: var(
      --haus-facetFiltersAccordion__checkboxRoot__checked__background-color,
      var(--haus-color-body)
    );
    border-color: var(
      --haus-facetFiltersAccordion__checkboxRoot__checked__border-color,
      var(--haus-color-body)
    );
    color: var(--haus-facetFiltersAccordion__checkboxRoot__checked__color, #fff);
  }
}

.checkboxIndicator {
  width: var(--haus-facetFiltersAccordion__checkboxIndicator__width, 100%);
  height: var(--haus-facetFiltersAccordion__checkboxIndicator__height, 100%);
  display: var(--haus-facetFiltersAccordion__checkboxIndicator__display, flex);
  align-items: var(--haus-facetFiltersAccordion__checkboxIndicator__align-items, center);
  justify-content: var(--haus-facetFiltersAccordion__checkboxIndicator__justify-content, center);
}

.srOnly {
  position: var(--haus-facetFiltersAccordion__srOnly__position, absolute) !important;
  width: var(--haus-facetFiltersAccordion__srOnly__width, 1px) !important;
  height: var(--haus-facetFiltersAccordion__srOnly__height, 1px) !important;
  padding: var(--haus-facetFiltersAccordion__srOnly__padding, 0) !important;
  margin: var(--haus-facetFiltersAccordion__srOnly__margin, -1px) !important;
  overflow: var(--haus-facetFiltersAccordion__srOnly__overflow, hidden) !important;
  clip: var(--haus-facetFiltersAccordion__srOnly__clip, rect(0, 0, 0, 0)) !important;
  white-space: var(--haus-facetFiltersAccordion__srOnly__white-space, nowrap) !important;
  border: var(--haus-facetFiltersAccordion__srOnly__border, 0) !important;
}
